export type AppLanguage = "en" | "es";

export type LanguagePreference = "EN" | "ES";

export const SUPPORTED_LANGUAGES: AppLanguage[] = ["en", "es"];

export const DEFAULT_LANGUAGE: AppLanguage = "en";

const STORAGE_KEY = "language.preference";

export const isAppLanguage = (value: unknown): value is AppLanguage => value === "en" || value === "es";

export const normalizeLanguage = (value: string | null | undefined): AppLanguage => {
	const base = (value ?? "").toLowerCase().split("-")[0];
	return isAppLanguage(base) ? base : DEFAULT_LANGUAGE;
};

export const resolveLinkLanguage = (lang: string | null, browserLanguage?: string): AppLanguage =>
	isAppLanguage(lang) ? lang : normalizeLanguage(browserLanguage);

export const languageFromPreference = (preference: LanguagePreference | null | undefined): AppLanguage =>
	preference === "ES" ? "es" : "en";

export const preferenceFromLanguage = (language: AppLanguage): LanguagePreference => (language === "es" ? "ES" : "EN");

export const readCachedLanguage = (): AppLanguage => {
	try {
		return normalizeLanguage(localStorage.getItem(STORAGE_KEY));
	} catch {
		return DEFAULT_LANGUAGE;
	}
};

export const writeCachedLanguageChecked = (language: AppLanguage): void => {
	localStorage.setItem(STORAGE_KEY, language);
};

export const writeCachedLanguage = (language: AppLanguage): void => {
	try {
		writeCachedLanguageChecked(language);
	} catch {
		// QuotaExceededError / disabled storage — keep the in-memory language
	}
};

let localLanguageChangeMade = false;

export const markLocalLanguageChange = (): void => {
	localLanguageChangeMade = true;
};

export const hasLocalLanguageChange = (): boolean => localLanguageChangeMade;

export const resetLocalLanguageChangeForTests = (): void => {
	localLanguageChangeMade = false;
};
